import { combineReducers } from "redux";
import { JOB_ATTACHMENT_FETCHED } from "../types";

const allAttachments = (state = [], action) => {
  switch (action.type) {
    case JOB_ATTACHMENT_FETCHED:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({ allAttachments });



// WEBPACK FOOTER //
// ./src/reducers/jobAttachmentsReducer.js